import React, { useState } from "react"
import { navigate } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { getShopifyImage } from "gatsby-source-shopify"
import clsx from "clsx"
import LinkButton from "@components/common/LinkButton"
import { useWindowSize } from "@components/helpers/useWindowSize"

const DisplayCard = ({data, cardStyles, imageClass, fullHeightImage = false, ariaLabel= '', width, height}) => {
    // console.log('dd',data?.image?.src)
	const { isMobile } = useWindowSize()
	const [imageLoaded, setImageLoaded] = useState(false)

    const originalImage = React.useMemo(() => {
        const imageSrc = data?.image?.src;

        if (!imageSrc) {
            //console.warn("Image source is undefined, falling back to placeholder or null.");
            return null; // Or return a placeholder image object here if needed
        }


        const image = {
            originalSrc: data?.image?.src,
            width: data?.image?.gatsbyImageData?.width,
            height: data?.image?.gatsbyImageData?.height,
        }
    
        return getShopifyImage({
            image: image,
            layout: "constrained",
            crop: "contain",
            width: width,
            height: height,
        });
    }, [data?.image?.src]);
    
    const [hovered, setHovered] = useState(false)

    const handleImageClick = () => {
        // console.log("handle;",data?.handle)
        if(data?.handle) {
            navigate(`/collections/${data?.handle}`)
        }
    }

    return (
        <React.Fragment>
            <div
                className={`relative flex-auto md:flex-1 cursor-pointer ${cardStyles ? cardStyles : 'displaycard-default'}`}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                aria-label={'ariaLabel'}
            >
                <div className="relative w-full h-full">
                    {!imageLoaded && (
						<div className="absolute w-full h-full skeleton-bg z-20">
							<div className="w-full h-full" />
							<div className={clsx("w-full mt-4", isMobile || data?.description?.length > 30 ? 'h-10' : 'h-5')} />
						</div>
					)}
					<div className={clsx('relative skeleton-preload', imageLoaded && '!opacity-100')}>
						{
							data?.image?.src ? (
								<GatsbyImage
									className={`lg:max-h-[390px] object-cover`}
									alt={data?.name || data?.name}
									image={originalImage}
									onClick={() => handleImageClick()}
									onLoad={() => setImageLoaded(true)}
								/>
							) : (
								<img
									src={`${data?.image}`}
									className={`${imageClass ?? 'lg:max-h-[390px] object-cover'}`}
									alt={data?.name || data?.name}
									onClick={() => handleImageClick()}
									onLoad={() => setImageLoaded(true)}
									loading="lazy"
								/>
							)
						}

						{data?.description && (
							<p className="product-description">{data?.description}</p>
						)}
					</div>
                </div>

                <LinkButton
                    to={`/collections/${data?.handle}`}
                    label={data?.buttonLabel}
                    className={clsx('mt-4 self-end w-full text-wrap text-sm md:text-base underline underline-offset-4 lg:no-underline', hovered ? '!underline font-semibold underline-offset-4' : 'font-normal', !imageLoaded && 'hidden')}
                />
            </div>
        </React.Fragment>
    );
    }

export default DisplayCard